var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-by-step-guide"},[_c('DownloadSetupApp'),_c('CreateSite'),_c('AddProduct'),_c('DecideOnConnectivity'),_c('SyncProducts'),_c('Handover'),_c('ClaimOwnership'),_c('ActivateLicenses')],1)}
var staticRenderFns = []

export { render, staticRenderFns }